export var GRID_ITEM_CLASS_PREFIX = 'GridItem';
export var gridItemRoot = 'GridItemRoot';